'use client'

import { Underline } from 'lucide-react'
import * as React from 'react'
import { PluginComponent } from 'react-markdown-editor-lite'

/**
 * Replaces react-markdown-editor-lite's default underline (`++text++`),
 * which is non-standard and does not render. Wraps with HTML <u> instead
 * (works with MarkdownPreview + rehype-raw).
 */
class MarkdownUnderlineToolbarPlugin extends PluginComponent {
  private handleKeyboard = {
    key: 'u',
    keyCode: 85,
    withKey: ['ctrlKey' as const],
    callback: () => this.insertUnderline(),
  }

  componentDidMount() {
    if (this.editorConfig.shortcuts) {
      this.editor.onKeyboard(this.handleKeyboard)
    }
  }

  componentWillUnmount() {
    this.editor.offKeyboard(this.handleKeyboard)
  }

  private insertUnderline = () => {
    const selection = this.editor.getSelection()
    const selectedText = selection.text || 'text'
    const wrapped = `<u>${selectedText}</u>`

    this.editor.insertText(wrapped, true, {
      start: 3,
      end: 3 + selectedText.length,
    })
  }

  render() {
    return (
      <span
        className="button button-type-underline"
        title="Underline"
        onClick={this.insertUnderline}
        role="button"
        tabIndex={0}
        onKeyDown={event => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            this.insertUnderline()
          }
        }}
      >
        <Underline className="rmel-icon" aria-hidden size={16} strokeWidth={2.25} />
      </span>
    )
  }
}

MarkdownUnderlineToolbarPlugin.pluginName = 'font-underline'

export default MarkdownUnderlineToolbarPlugin
